import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
    />
    <path
      fill="#F7A600"
      d="M12.052 7.4a.937.937 0 0 0-.934.94c0 .518.418.938.934.938h.01c.515 0 .934-.42.934-.939a.937.937 0 0 0-.935-.939h-.009ZM10.1 10.922c0-.433.35-.783.783-.783h1.565a.783.783 0 0 1 .782.81v3.886h.783a.783.783 0 0 1 0 1.565h-3.13a.783.783 0 0 1 0-1.565h.782v-3.13h-.782a.783.783 0 0 1-.783-.783Z"
    />
  </svg>
);
export default SvgTwoColorInfo;
